export const CHARACTERISTIC_FILTER_ID = 'has_characteristics';
export const CHARACTERISTIC_ALL_FILTER_ID = 'has_all_characteristics';
